"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logExecutionTime = logExecutionTime;
function logExecutionTime(logger, scope, executionTimeMs, loggerPayload) {
    logger.log({
        message: `Execution time`,
        payload: {
            ...loggerPayload,
            executionTimeMs,
            scope,
        },
    });
}
//# sourceMappingURL=logExecutionTime.js.map